var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 52.5H17.5C16.1739 52.5 14.9021 51.9732 13.9645 51.0355C13.0268 50.0979 12.5 48.8261 12.5 47.5V32.5C12.5 31.1739 13.0268 29.9021 13.9645 28.9645C14.9021 28.0268 16.1739 27.5 17.5 27.5H42.5C43.1625 27.5 43.795 27.63 44.375 27.8625M20 27.5V17.5C20 14.8478 21.0536 12.3043 22.9289 10.4289C24.8043 8.55357 27.3478 7.5 30 7.5C32.6522 7.5 35.1957 8.55357 37.0711 10.4289C38.9464 12.3043 40 14.8478 40 17.5V27.5M47.5 55V55.025M47.5 47.5C48.6207 47.4964 49.7079 47.117 50.5874 46.4224C51.467 45.7278 52.0881 44.7582 52.3514 43.6688C52.6147 42.5795 52.5049 41.4333 52.0396 40.4137C51.5743 39.3941 50.7804 38.56 49.785 38.045C48.7904 37.5355 47.6528 37.3776 46.557 37.5968C45.4613 37.8161 44.472 38.3996 43.75 39.2525M27.5 40C27.5 40.663 27.7634 41.2989 28.2322 41.7678C28.7011 42.2366 29.337 42.5 30 42.5C30.663 42.5 31.2989 42.2366 31.7678 41.7678C32.2366 41.2989 32.5 40.663 32.5 40C32.5 39.337 32.2366 38.7011 31.7678 38.2322C31.2989 37.7634 30.663 37.5 30 37.5C29.337 37.5 28.7011 37.7634 28.2322 38.2322C27.7634 38.7011 27.5 39.337 27.5 40Z",
    stroke: "#DE1F4C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockQuestion);
export default __webpack_public_path__ + "static/media/lock-question.d242f2d047c788ac78e7c05ce381f73e.svg";
export { ForwardRef as ReactComponent };